module.exports = __webpack_public_path__ + "img/public/AdminIcons/adminImportIcon.svg?c85d7e7b";